import { formatCurrencyNatural } from '@frontend/duck-tape';
import { Text, XStack, YStack } from '@frontend/web-react';
import { safeCss } from '@frontend/web-utils';

export type PlanCardProps = {
  estimatedTasks: string;
  isFocusable?: boolean;
  isPricingLoading?: boolean;
  isSelected: boolean;
  onSelect: () => void;
  planLabel: string;
  primaryPrice: Cent;
  secondaryPrice?: Cent;
};

export const PlanCard = ({
  estimatedTasks,
  isFocusable = false,
  isPricingLoading = false,
  isSelected,
  onSelect,
  planLabel,
  primaryPrice,
  secondaryPrice,
}: PlanCardProps) => {
  const hasDiscount = typeof secondaryPrice !== 'undefined';
  return (
    <XStack
      alignItems="center"
      aria-checked={isSelected}
      borderColor={isSelected ? 'borderSecondary' : 'borderTertiary'}
      borderWidth={2}
      className={safeCss('h-full cursor-pointer hover:border-borderSecondary')}
      gapX="lg"
      onClick={onSelect}
      onKeyDown={(e) => {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          onSelect();
        }
      }}
      p="md"
      px="lg"
      radius="lg"
      role="radio"
      tabIndex={isFocusable ? 0 : -1}
    >
      <XStack flex={1}>
        <YStack flex={1} gapY="xs">
          <Text type="h4">{planLabel}</Text>
          {isPricingLoading ? (
            <YStack gapY="xs">
              <YStack bg="lineGray" height={24} radius="md" width={88} />
              <YStack bg="lineGray" height={16} radius="md" width={64} />
            </YStack>
          ) : (
            <>
              <XStack alignItems="center" gapX="xs">
                <Text className="leading-6" type="h2">
                  {formatCurrencyNatural(primaryPrice)}
                </Text>
                <Text className="leading-4" type="p-md">
                  /mo
                </Text>
              </XStack>
              {hasDiscount ? (
                <Text className="line-through text-red-500" type="p-md">
                  {formatCurrencyNatural(secondaryPrice)}/mo
                </Text>
              ) : null}
            </>
          )}
        </YStack>
        <YStack className="text-right" justifyContent="center">
          <Text color="primary" textAlign="end" type="p-sm">
            {estimatedTasks}
          </Text>
        </YStack>
      </XStack>
    </XStack>
  );
};
